import { createTheme } from '@mui/material/styles';
import { CommonThemeOptions } from './commonTheme';
import { type IThemeOptions } from './index';

export const Wind2NotesOptions: IThemeOptions = {
  ...CommonThemeOptions,
  themeName: 'Wind2Notes',
  components: {
    ...CommonThemeOptions.components,
    MuiButton: {
      styleOverrides: {
        textPrimary: {
          color: '#32AA8C',
          '&.Mui-disabled': {
            color: '#375D53',
          },
        },
        outlinedPrimary: {
          color: '#32AA8C',
          '&.Mui-disabled': {
            color: '#375D53',
            border: '1px solid #375D53',
          },
        },
        containedPrimary: {
          backgroundColor: '#32AA8C',
          '&.Mui-disabled': {
            backgroundColor: '#375D53',
            color: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        primary: {
          color: '#fff',
          backgroundColor: '#32AA8C',
          background: '#32AA8C', // transcribe button
          '&.Mui-disabled': {
            background: '#caced133',
            color: '#ffffff42',
          },
        },
      },
    },
  },
  palette: {
    ...CommonThemeOptions.palette,
    primary: {
      main: '#32AA8C',
      light: '#67D3B8',
      dark: '#247E67',
      contrastText: '#fff',
    },
  },
};

export const Wind2NotesTheme = createTheme(Wind2NotesOptions);
